export default __webpack_public_path__ + "static/vaud-bg-0735e2745ec041f331723d794e684e87.jpg";